export default __webpack_public_path__ + "static/media/Crypto-Stalker.8f02dca3.png";